import { images } from "@/data/images";

// "Beyond Basketball" — longer-form stories of character and growth.
// `person` is the athlete/staff member the story is about.
// `body` is an array of paragraphs shown in the Read More dialog.
export const successStories = [
  {
    id: "s1",
    tag: "Full Circle",
    title: "From Player to Coach",
    person: "David Xia",
    summary:
      "One of University Hill's top players is back with the program, now as our Lead Strength & Conditioning Coach.",
    image: images.davidXia,
    body: [
      "David was one of the top players to come through the University Hill basketball program. He competed with passion, worked hard, and left a lasting impression during his time as a player.",
      "Today, he's returning to the program in a new role as our Lead Strength & Conditioning Coach while pursuing his Master of Physical Therapy at the University of British Columbia.",
      "Watching a former player choose to give back to the next generation is one of the most rewarding parts of coaching. It's a reminder that the relationships built through basketball don't end when a player's playing career does. They continue through mentorship, service, and a desire to help others grow.",
      "I'm grateful to have David back with the program and excited for the impact he'll have on the development of our athletes, both on and off the court.",
    ],
  },
  {
    id: "s2",
    tag: "Leadership",
    title: "Heart Over Height",
    person: "Almas Adil",
    summary:
      "The smallest player in the gym earned the trust of his teammates, who chose him as their captain.",
    image: images.almasAdil,
    imgPosition: "top",
    body: [
      "When Almas first joined our offseason training in 2024, he was the smallest player in the gym. My first impression was simple: he had an incredible work ethic, but because of his size, he probably wasn't going to see many minutes.",
      "Over time, he proved me wrong.",
      "Practice after practice, Almas earned my trust through his consistency, competitiveness, and willingness to do the little things. He showed that impact isn't determined by size, but by the value you bring to a team every day.",
      "By his senior year, the most rewarding part wasn't seeing him play more. It was watching his teammates vote him as team captain. I didn't choose him for that role; they did. To me, there is no greater measure of leadership than earning the trust and respect of your peers.",
      "Almas reminded me that leadership isn't given. It's earned.",
    ],
  },
  {
    id: "s3",
    tag: "Character",
    title: "When One Door Closed, Another Opened",
    person: "Eric Xu",
    summary:
      "When injuries ended his playing career, Eric found another way to serve, and made the whole program better.",
    image: images.ericHoop,
    body: [
      "Eric was originally a player in our program, but recurring injuries brought his playing career to an early end. Rather than walking away from the team, he chose to find a different way to contribute.",
      "He stepped into the role of student manager and quickly became an essential part of our program.",
      "Beyond the day-to-day responsibilities, Eric developed a statistical tracking system that helped our coaching staff better understand why we were losing games and where we could improve. Those insights became an important part of our decision-making and played a role in helping us win several close games throughout the season.",
      "Eric reminded me that your impact on a team is never limited to the role you hold. When one opportunity was taken away, he found another way to serve, and our program was better because of it.",
    ],
  },
  {
    id: "s4",
    tag: "Full Circle",
    title: "From Player to DJ",
    person: "Ali Rahbari · DJ Salout",
    summary:
      "Ever been to an NBA game? You can get much of that same experience at a University Hill game, thanks to a former player turned DJ.",
    image: images.aliRahbari,
    body: [
      "Ever been to an NBA game? The energy, the sound, the moment before tip-off. You can get much of that same experience at a University Hill game, thanks to a former player turned DJ.",
      "After graduating, Ali's playing days came to an end, but his connection to the program never did. Today, better known as DJ Salout, he creates the soundtrack to every home game, bringing energy to our players and helping transform our gym into an atmosphere our community looks forward to experiencing.",
      "The best programs aren't remembered only for wins and losses. They're remembered for how they make people feel. Thanks to Ali, our players compete in an environment that feels special, and our fans leave with memories that extend beyond the final score.",
      "His role may have changed, but his impact on our program continues to grow.",
    ],
  },
  {
    id: "s5",
    tag: "Full Circle",
    title: "From Team Photographer to Professional Photographer",
    person: "Mark Zhuang",
    summary:
      "A former student manager turned his passion into a profession, and still comes back to capture the team, for free.",
    image: images.markPhoto,
    caption: "My favourite photo from the 2025–2026 season, by Mark.",
    body: [
      "He started with us as a team manager and photographer, always around the game even without stepping on the floor. Along the way, he discovered a love for photography.",
      "Today he's a professional photographer, and he still comes back to shoot our games and team photos at no charge, giving back to the program that gave him a start.",
      "The images he captures become part of our story. His journey is a reminder that the lessons learned around a team carry into every career.",
    ],
  },
  {
    id: "s6",
    tag: "Development",
    title: "When Talent Works Hard",
    person: "Jack Gordon",
    summary:
      "\u201CHard work beats talent when talent doesn't work.\u201D Tim Notke. That's true. But it's even harder to beat talent that does work hard.",
    image: images.jackGordon,
    imgPosition: "center 38%",
    body: [
      "\u201CHard work beats talent when talent doesn't work.\u201D Tim Notke",
      "That's true. But it's even harder to beat talent that does work hard.",
      "Jack was blessed with size, athleticism, and natural ability, but what separated him was his commitment to improving every single day. He embraced coaching, welcomed challenges, and consistently put in the work long after practice ended.",
      "That combination earned him the opportunity to attend prep school and compete in the Nike EYBL, taking the next step in his basketball journey.",
      "When Jack reaches Division I basketball and someone asks me if I'm surprised, my answer will be simple: no. I've watched the work.",
    ],
  },
];
